'use client';

import { Result } from '@headless-workspace/core-domain';
import { RumLogger } from '@headless-workspace/utils';
import useSWR, { Fetcher, SWRConfiguration } from 'swr';

type SWRFetcher<T> = Fetcher<Result<T>, string>;

const USE_SWR_RESULT_ERROR_NAMESPACE = 'USE_SWR_RESULT';

export const useSwrResult = <T>(
    revalidationKey: string | string[] | null,
    fetcher: SWRFetcher<T>,
    options: Partial<SWRConfiguration> = {},
) => {
    const fetcherGuard: Fetcher<Result<T>> = async (...args: Parameters<SWRFetcher<T>>) => {
        const result = await fetcher(...args);

        // Throw error in case of failure to trigger retry exponential backoff
        if (result.type === 'failure') {
            const error = new Error(result.meta.message);
            error.name = `${USE_SWR_RESULT_ERROR_NAMESPACE}:${result.meta.code}`;

            new RumLogger().error(USE_SWR_RESULT_ERROR_NAMESPACE, error);
            throw error;
        }

        return result;
    };
    return useSWR(revalidationKey, fetcherGuard, options);
};
